import React from "react";
import "./Status.css";

function Status() {
  return <img className="status" src="/girl.jpg" alt="" />;
}

export default Status;
